import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnimateDirective } from '../directives/animate.directive';

@Component({
  selector: 'app-segments-v2',
  standalone: true,
  imports: [CommonModule, AnimateDirective],
  template: `
    <section id="segments" class="pb-12 md:pb-16 lg:pb-24 bg-[#0a0a0a] relative">

      <div class="container mx-auto px-4 md:px-6 relative z-10">

        <!-- Header Section -->
        <div class="mb-8 md:mb-10">
          <h2 appAnimate class="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 leading-tight tracking-tight">
            Onde a
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 40" fill="none"
                 class="inline-block h-2.5 md:h-4 w-auto ml-1 mr-0.5 -mt-0.5 md:-mt-1 align-middle opacity-90">
              <circle cx="20" cy="20" r="20" fill="#FF6900"/>
              <circle cx="80" cy="20" r="20" fill="#FF6900"/>
            </svg>beetrack
            gera
            <span class="relative inline-block mx-1">
              impacto
              <span class="absolute -bottom-2 left-0 w-full h-1 bg-[#FF5500]"></span>
            </span>
            imediato
          </h2>
          <p appAnimate [delay]="100" class="text-gray-500 text-base md:text-lg font-medium tracking-wide">
            Cada setor tem uma dor diferente. A beetrack tem uma solução para cada uma delas.
          </p>
        </div>

        <!-- Cards Layout -->
        <div class="flex flex-wrap justify-center gap-3 md:gap-4 lg:gap-5">

          @for (seg of segments; track seg.title; let i = $index) {
            <div appAnimate [delay]="150 + (i * 100)" class="h-[220px] md:h-[240px] lg:h-[220px] xl:h-[260px] 2xl:h-[300px] w-full md:w-[calc(50%-1.5rem)] lg:w-[calc(33.333%-1.5rem)]">
              <div class="group relative h-full w-full rounded-2xl overflow-hidden cursor-default border border-white/5 bg-[#1c1c1c] shadow-2xl hover:border-[#FF5500]/30 transition-all duration-500">

                <!-- Background Image -->
                <img [src]="seg.img" [alt]="seg.title"
                     class="absolute inset-0 w-full h-full object-cover object-center opacity-100 transition-all duration-700 group-hover:scale-110"
                     width="400"
                     height="260"
                     loading="lazy">

                <!-- Gradient Overlay -->
                <div class="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-80 transition-opacity duration-300 group-hover:opacity-70"></div>

                <!-- Content -->
                <div class="absolute bottom-0 left-0 p-4 md:p-5 lg:p-6 w-full z-20">
                  <div class="w-8 h-1 bg-[#FF5500] mb-3 lg:mb-4 group-hover:w-16 transition-all duration-500"></div>
                  <h2 class="text-lg md:text-xl lg:text-lg xl:text-xl font-bold text-white leading-tight shadow-black drop-shadow-lg mb-1">
                    {{ seg.title }}
                  </h2>
                  @if (seg.description) {
                    <p class="text-xs text-gray-300 leading-snug opacity-0 group-hover:opacity-100 transition-opacity duration-300 mt-1">
                      {{ seg.description }}
                    </p>
                  }
                </div>

              </div>
            </div>
          }

        </div>

      </div>
    </section>
  `
})
export class SegmentsV2Component {
  segments = [
    {
      title: 'Frigoríficos e açougues',
      img: '/images/frigorificos.webp',
      description: 'Maior índice de autuações por NR 36 no país. Risco alto, solução simples.'
    },
    {
      title: 'Fábrica de alimentos',
      img: '/images/fabrica-alimentos-2.webp',
      description: 'Câmaras frias de alto movimento. Cada colaborador precisa de controle individual.'
    },
    {
      title: 'Dist. de alimentos',
      img: '/images/dist-alimentos.webp',
      description: 'Turnos longos e câmaras constantes. Documentação automática para cada turno.'
    },
    {
      title: 'Supermercados e atacadistas',
      img: '/images/supermercados.webp',
      description: null
    },
    {
      title: 'Rede de hotéis e restaurantes',
      img: '/images/restaurantes.webp',
      description: null
    },
    {
      title: 'Dist. de medicamentos',
      img: '/images/dist-medicamentos.webp',
      description: null
    },
  ];
}
